export var SubscribedThermostatReadingType;
(function (SubscribedThermostatReadingType) {
    SubscribedThermostatReadingType["READING_AND_CONFIGURATION"] = "READING_AND_CONFIGURATION";
    //Below are actually deprecated,
    //but actually needed for old edgeApp versions
    SubscribedThermostatReadingType["READING"] = "READING";
    SubscribedThermostatReadingType["CONFIGURATION"] = "CONFIGURATION";
})(SubscribedThermostatReadingType || (SubscribedThermostatReadingType = {}));
